import Module from '@/store/resource/common/module';
import FileFolders from '@/store/resource/fileFolders';
let module = new Module(new FileFolders());

module.add('mutations', {
  setActiveFolder(state, folderId) {
    state.activeFolderId = folderId;
  },
  removeFileFromFolder(state, data) {
    const { folder_id, id } = data;
    const folder = state.all.find((f) => f.id === folder_id);
    if (folder) {
      folder.files_count--;
    }
  },
});

module.add('state', {
  activeFolderId: null,
});

export default module.create();
